import { Maybe } from '../../../../utils/maybe';
import { Emojis } from '../../pages/People/Announcements/types';
import { ReactionFragment } from '../../__generated__/graphql';
import {
  getSalesforceObjectName,
  SalesforceObjectName,
} from '../../../../utils/objectTypes';

export type CommentFile = {
  fileName: string;
  fileBase64?: string;
  size?: number;
  fileType: string;
  link?: string;
};

export type CommentPointer = {
  recordId: string;
  commentId?: string;
};

export type Comment = {
  id?: Maybe<string>;
  employee: Employee;
  text: Maybe<string>;
  createdDate: Date;
  selectedEmojis?: Emojis;
  files: CommentFile[];
  images: CommentFile[];
  isNew?: boolean;
  reactions: ReadonlyArray<ReactionFragment>;
  mentionedEmployees: MentionEmployee[];
};

export type UpsertComment = {
  id?: Maybe<string>;
  employee: Employee;
  text: string;
  createdDate: Date;
  selectedEmojis?: Emojis;
  files: CommentFile[];
  mentionedEmployees: MentionEmployee[];
};

export type Employee = {
  id: string;
  name: string;
  avatarUrl?: Maybe<string>;
  position?: Maybe<string>;
};

/* eslint-disable no-unused-vars */
export enum ActionTypes {
  Image = 'IMAGE',
  File = 'FILE',
  Link = 'LINK',
}

export type ActionType =
  | ActionTypes.Image
  | ActionTypes.File
  | ActionTypes.Link;

// Only include object types that support comments
export enum RelatedObjectNames {
  Celebration = SalesforceObjectName.Celebration,
  WorkflowItem = SalesforceObjectName.WorkflowItem,
  Expense = SalesforceObjectName.Expense,
  ExpenseGroup = SalesforceObjectName.ExpenseGroup,
  EmployeeCertificate = SalesforceObjectName.EmployeeCertificate,
  Absence = SalesforceObjectName.Absence,
  Document = SalesforceObjectName.Document,
  Inventory = SalesforceObjectName.Inventory,
  Ticket = SalesforceObjectName.Ticket,
  Announcements = SalesforceObjectName.Announcements,
  TimeSheetDay = SalesforceObjectName.TimeSheetDay,
  Candidate = SalesforceObjectName.Candidate,
  CandidateEvaluation = SalesforceObjectName.CandidateEvaluation,
  EmployeeDataChangeRequest = SalesforceObjectName.EmployeeDataChangeRequest,
}

export type RelatedObjectName = RelatedObjectNames;

export const getCommentSupportedObjectName = (
  objectName: string,
): RelatedObjectName => {
  const salesforceObject = getSalesforceObjectName(objectName);

  if (!salesforceObject) {
    throw new Error(`Invalid object type ${objectName}`);
  }

  if (!(salesforceObject in RelatedObjectNames)) {
    throw new Error(`Object type ${objectName} does not support comments`);
  }

  return salesforceObject as Extract<SalesforceObjectName, RelatedObjectName>;
};

export type MentionEmployee = {
  id: string;
  hasAccess: boolean;
  name: string;
  avatarUrl: string | null;
  position: string;
  department: string;
  location: string;
  companyEmail: string;
  phone: string;
  manager: Manager | null;
};

type Manager = {
  id: string;
  name: string;
};
